import { useMemo } from 'react'
import { parse as parseYaml } from 'yaml'

export function useDefinitionCounts(yamlContent: string) {
  return useMemo(() => {
    try {
      const parsed = parseYaml(yamlContent)
      const phases = Array.isArray(parsed?.phases) ? parsed.phases : []
      const nodeCount = phases.reduce((sum: number, phase: { branches?: { nodes?: unknown[] }[] }) => {
        const branches = Array.isArray(phase?.branches) ? phase.branches : []
        return sum + branches.reduce((bSum: number, branch) => {
          return bSum + (Array.isArray(branch?.nodes) ? branch.nodes.length : 0)
        }, 0)
      }, 0)
      return { phases: phases.length, nodes: nodeCount }
    } catch {
      return null
    }
  }, [yamlContent])
}
